import React, { useState, useRef, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';

const TOKEN = document.querySelector("[name='csrf-token']")?.content;

export default function FormatEditor({ value, column, onSave, onCancel }) {
  const [search, setSearch] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const anchorRef = useRef(null);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (anchorRef.current) {
      const rect = anchorRef.current.getBoundingClientRect();
      const popoverWidth = 260;
      let left = rect.left;
      if (left + popoverWidth > window.innerWidth) {
        left = window.innerWidth - popoverWidth - 16;
      }
      setPos({ top: rect.bottom + 4, left });
    }
    fetchOptions('bw-blank');
  }, []);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onCancel(); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onCancel]);

  const fetchOptions = useCallback(async (term) => {
    setLoading(true);
    try {
      const res = await fetch(
        `/formatos/get_formats_values_format/${column.id}/${encodeURIComponent(term)}/0/0`,
        { headers: { 'X-CSRF-Token': TOKEN, 'Content-Type': 'application/json' } }
      );
      const json = await res.json();
      const data = json.data || [];
      setOptions(term === 'bw-blank' ? data.slice(0, 10) : data);
    } catch (err) {
      console.error('FormatEditor fetch error:', err);
    } finally {
      setLoading(false);
    }
  }, [column.id]);

  const handleSearchChange = (e) => {
    const val = e.target.value;
    setSearch(val);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (val.length >= 3) {
      debounceRef.current = setTimeout(() => fetchOptions(val), 300);
    } else if (val.length === 0) {
      debounceRef.current = setTimeout(() => fetchOptions('bw-blank'), 300);
    }
  };

  const handleSelect = (opt) => {
    onSave(opt.value, []);
  };

  const dropdown = ReactDOM.createPortal(
    <div className="cm-format-popover" style={{ top: pos.top, left: pos.left }}>
      <div className="cm-format-popover__header">
        <span className="cm-format-popover__title">{column.name}</span>
      </div>

      <div className="cm-format-popover__search">
        <i className="fas fa-search" />
        <input
          type="text"
          placeholder="Buscar (min. 3 caracteres)..."
          value={search}
          onChange={handleSearchChange}
          autoFocus
        />
      </div>

      <div className="cm-format-popover__list">
        {loading ? (
          <div className="cm-format-popover__loading">
            <i className="fas fa-spinner fa-spin" /> Buscando...
          </div>
        ) : options.length === 0 ? (
          <div className="cm-format-popover__empty">Sin resultados</div>
        ) : (
          options.map((opt, i) => (
            <div
              key={i}
              className="cm-format-popover__option"
              onClick={() => handleSelect(opt)}
            >
              {opt.label}
            </div>
          ))
        )}
      </div>

      <div className="cm-format-popover__actions">
        <button className="cm-btn cm-btn--sm" onClick={() => onSave('', [])}>
          <i className="fas fa-eraser" /> Limpiar
        </button>
        <button className="cm-btn cm-btn--sm" onClick={onCancel}>
          Cancelar
        </button>
      </div>
    </div>,
    document.body
  );

  return (
    <>
      <span ref={anchorRef} />
      {dropdown}
    </>
  );
}
